import { infer as Infer, z } from 'zod';

export const groupMemberEditSchema = z.object({
  userIds: z.array(z.number()).optional(),
  groupIds: z.array(z.number()).optional(),
  add: z.boolean().optional(),
  remove: z.boolean().optional(),
});

export type GroupMemberEditSchema = Infer<typeof groupMemberEditSchema>;
